module.exports = __webpack_public_path__ + "static/media/1POLICY5.9aa30cac.jpg";